import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { PaymentIconComponent } from '../../../ui/display/payment-icon/payment-icon.component';
@Component({
    selector: 'account-saved-card-body',
    templateUrl: './account-saved-card-body.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, PaymentIconComponent]
})
export class AccountSavedCardBodyComponent {
    @Input()
    card?: CreditCard;
}
